<div class="container" [ngClass]="{'bg-gray': subscribeText && !modelService.me.team.subscribed}">

    <div class="accent" [hidden]="!subscribeText">
        <h1 class="accent">{{ subscribeText }}</h1>
        <sfx-plans class="sfx-plans" [hidden]="modelService.me.team.payment_type === 'free'" [fromBilling]="true" data-layout="column">

        </sfx-plans>
    </div>

    <div class="billingInfoText" [hidden]="!(modelService.me.team.payment_type === 'samsung')">
        <p>
            <span [translate]="'Your team is currently on the {{ plan }} plan'" [translateParams]="{plan: modelService.me.team.plan === 4 ? 'Pro' : 'Growth'}"></span>.
        </p>
        <p class="billingPadding">
            <span translate>You can manage your subscription and billing details from</span>
            <a href="https://www.samsung.com/us/business/account/login/" target="_blank" rel="noopener">
                <span translate>your Samsung Business account</span>
            </a>.
        </p>
    </div>

    <div class="billingInfoText" [hidden]="!(billingOverview && doneLoading && modelService.me.team.subscribed && modelService.me.team.payment_type !== 'free' && !showPlans)">
        <p *ngIf="modelService.me.is_delinquent" class="warning">
            <span [innerHtml]="getFailedPaymentAttemptsText()"></span>
            <span>{{ getNextPaymentAttemptText() }}</span>
            <span>{{ getPaymentFailureMessage() }}</span>
        </p>
        <p *ngIf="!modelService.me.is_delinquent && !billingOverview?.cancel_at_period_end">
            <span translate>Your team is currently paying </span><b>{{ billingOverview?.billing_frequency }}</b>
            <span *ngIf="modelService.me.team.plan !== 5">
                (<a role="button" (click)="updateBillingFrequency()"><span translate>update billing frequency</span></a>)
            </span>
            <span>
                <span translate>on the </span><b>{{ billingOverview?.plan_name }}</b> <span translate> plan</span>
                <span *ngIf="modelService.me.team.plan !== 5">
                    (<a role="button" (click)="updatePlan()"><span translate>update plan</span></a>)
                </span>.
            </span>
        </p>
        <p *ngIf="!modelService.me.is_delinquent && !billingOverview?.cancel_at_period_end" class="billingPadding">
            <span translate>Your plan will renew on </span><b>{{ billingOverview?.subscription_renewal_date }}</b> <span translate> for </span>
            <b>
                <span dir="ltr" [innerHTML]="billingOverview?.htmlEncodedBillingCurrency"></span>
                {{ (billingOverview?.billing_amount || 0) | number:'1.2-2' }}
            </b>
            <span *ngIf="billingOverview?.billing_currency === 'EUR'"> <span translate>excl. VAT</span></span>
            <span translate>(If you have a credit this will be used)</span>.
        </p>
        <p *ngIf="billingOverview?.cancel_at_period_end">
            <span translate>Your subscription will cancel on </span> <b>{{ billingOverview?.subscription_renewal_date }}</b>
            <span *ngIf="(billingOverview?.billing_amount || 0) > 0">
                <span translate> and you will be charged for </span> <b>
                    <span dir="ltr" [innerHTML]="billingOverview?.htmlEncodedBillingCurrency"></span>
                    {{ (billingOverview?.billing_amount || 0) | number:'1.2-2' }}
                </b>.
            </span>
        </p>
        <p *ngIf="showChargeText" class="billingPadding">
            <span translate>You have an outstanding balance of </span>
            <b>
                <span dir="ltr" [innerHTML]="billingOverview?.htmlEncodedBillingCurrency"></span>
                {{ (billingOverview?.next_charge?.amount || 0) | number:'1.2-2' }}
            </b> 
            <span translate> which will be charged on </span>
            <b>{{ billingOverview?.next_charge?.date }}</b>.
            <a uiSref="settings.billingSettings.history"><span translate>More info in the history</span></a>.
        </p>
        <p *ngIf="discountText" [innerHTML]="discountText"></p>

        <p class="billingInfoSubheader" translate>Account status</p>
        <ul class="billingInfoList">
            <li [hidden]="!(billingOverview?.card_brand && billingOverview?.card_last4)">
                <span translate>Future charges will be billed to your </span><b>{{ billingOverview?.card_brand }}</b> <span translate> card ending in </span><b>{{ billingOverview?.card_last4 }}</b>
                (<a role="button" (click)="updateCard()"><span translate>update card details</span></a>).
            </li>
            <li [innerHTML]="payingHtmlText"></li>
            <li>
                <span translate>You have used </span>
                <b>
                    <a role="button" (click)="showCreditUsage()">{{ billingOverview?.credit_usage }}</a>
                    <span translate> of </span>{{ billingOverview?.credit_quota }}<span translate> lead credits </span>
                </b>
                (<a role="button" uiSref="credits">
                    <ng-container>{{ getCreditPackageText() }}</ng-container>
                </a>).
                <span translate>Your monthly usage will reset on </span>{{ billingOverview?.credit_reset_date }}.
            </li>
            <li>
                <span translate>You currently have a credit of </span><span dir="ltr" [innerHTML]="billingOverview?.htmlEncodedBillingCurrency"></span>
                {{ (billingOverview?.billing_credits || 0) | number:'1.2-2' }} <span translate> to use against future payments</span>.
                <a href="https://howto.salesflare.com/salesflare/billing-how-does-salesflare-billing-work" target="_blank" rel="noopener">
                    <span translate>More info on our billing policy</span>
                </a>.
            </li>
            <li [hidden]="!(!billingOverview?.card_brand || !billingOverview?.card_last4)">
                <span translate>You currently do not have a valid card associated with your account.
                Please update your card information </span>.
                (<a role="button" (click)="updateCard()"><span translate>update card details</span></a>)
            </li>
            <li>
                <span translate>Billing emails are sent to </span><b>{{ billingOverview?.billing_email }}</b>
            </li>
        </ul>

        <div class="billingPadding" *ngIf="showSCAButton">
            <p class="billingInfoSubheader" translate>Authentication needed</p>
            <p translate>
                Because of European regulation to protect consumers, your bank requires extra authentication on your latest payment.
            </p>
            <p class="billingPadding_bottom_half" translate>
                Failure to authenticate your payment within 15 days will result in your account being canceled.
            </p>
            <button mat-raised-button (click)="authorizePayment()" [disabled]="disableSCAButton" translate>
                Authenticate payment
            </button>
        </div>

        <p class="billingPadding billingPaddingPageEnd">
            <span translate>Please contact us for </span> 
            <a role="button" (click)="askBillingQuestion()"><span translate>billing questions</span></a> 
            <span translate> or to </span> 
            <a role="button" (click)="cancelBilling()"><span translate>cancel your account</span></a>.
        </p>
    </div>
</div>
